import patchEdipartChanges from '../requests/patchEdipartChanges';
import getEdipartsRequests from '../requests/getEdipartsRequests';
import newEdipartRequest from '../requests/newEdipartRequest';
import deleteEdipartRequest from '../requests/deleteEdipartRequest';
//import rdbClient from 'rdb-client';

async function executeGetEdiparts({ commit }) {
	let ediparts = await getEdipartsRequests();
	commit('setEdiparts', ediparts);
}

async function executeCreatePatchAndSave({ commit, state }, edipart) {
	let index = state.ediparts.findIndex(x => x.id === edipart.id);
	let foundEdipart = state.ediparts[index];
	//let patch = rdbClient.createPatch(foundEdipart,  edipart);
	await patchEdipartChanges(foundEdipart.id, edipart);
	commit('updateEdipartState', { index, edipart });
}

async function executeCreateEdipart({ commit }, edipart) {
	let response = await newEdipartRequest(edipart);
	commit('addNewEdipart', response);
}

async function executeDeleteEdipart({ commit }, edipart) {
	console.log(edipart);
	await deleteEdipartRequest(edipart.id);
	commit('removeEdipartFromList', edipart.id);
}

export default { executeGetEdiparts, executeCreatePatchAndSave, executeCreateEdipart, executeDeleteEdipart };